(function() {
  /* ── Block Justuno's third-party scroll-reset hijack on click events.
       Scoped to education template only (this section file). Justuno's ifm_4.1.js
       does `documentElement.scrollTop = 0` inside its global click handler, which
       causes scroll-to-top whenever the user taps anywhere far from the top of
       the page. We override the scrollTop setter to no-op only when the call
       originates from a stack containing 'justuno.com'. ── */
  (function() {
    try {
      var d = Object.getOwnPropertyDescriptor(Element.prototype, 'scrollTop');
      if (!d || !d.set) return;
      Object.defineProperty(Element.prototype, 'scrollTop', {
        configurable: true,
        get: d.get,
        set: function(v) {
          if (this === document.documentElement || this === document.body) {
            var s = (new Error().stack || '');
            if (s.indexOf('justuno.com') > -1) return;
          }
          return d.set.call(this, v);
        }
      });
    } catch (e) {}
  })();

  document.addEventListener('DOMContentLoaded', function() {
    var content = document.getElementById('edu-content');
    if (!content) return;

    /* ── Keep component titles from entering the document heading outline ── */
    var componentHeadings = content.querySelectorAll('.callout-box > h4, .info-box > h4, .tip-box > h4, .warning-box > h4');
    componentHeadings.forEach(function(heading) {
      var title = document.createElement('div');
      title.className = (heading.className ? heading.className + ' ' : '') + 'callout-title';
      title.innerHTML = heading.innerHTML;
      heading.parentNode.replaceChild(title, heading);
    });

    /* ── Key Takeaways Card Builder (fallback for H3+P format) ── */
    (function() {
      var allH3s = content.querySelectorAll('h3');
      var ktHeading = null;
      for (var t = 0; t < allH3s.length; t++) {
        var txt = allH3s[t].textContent.toLowerCase();
        if (txt.indexOf('key takeaway') > -1 || txt.indexOf('quick takeaway') > -1) {
          ktHeading = allH3s[t];
          break;
        }
      }
      if (!ktHeading) {
        var allH2s2 = content.querySelectorAll('h2');
        for (var t2 = 0; t2 < allH2s2.length; t2++) {
          var txt2 = allH2s2[t2].textContent.toLowerCase();
          if (txt2.indexOf('key takeaway') > -1 || txt2.indexOf('quick takeaway') > -1) {
            ktHeading = allH2s2[t2];
            break;
          }
        }
      }
      if (ktHeading && !content.querySelector('.key-takeaways-box')) {
        ktHeading.classList.add('key-takeaways-heading');
        var sEls = [];
        var cur2 = ktHeading.nextElementSibling;
        var stopTags = ktHeading.tagName === 'H2' ? ['H1','H2'] : ['H1','H2','H3'];
        while (cur2) {
          if (stopTags.indexOf(cur2.tagName) > -1) break;
          sEls.push(cur2);
          cur2 = cur2.nextElementSibling;
        }
        var subTag = ktHeading.tagName === 'H2' ? 'H3' : 'H4';
        var pairs = [];
        var used = new Set();
        for (var s = 0; s < sEls.length && pairs.length < 4; s++) {
          if (used.has(sEls[s]) || sEls[s].tagName !== subTag) continue;
          var heading = sEls[s];
          var pEl = null;
          for (var s2 = s+1; s2 < sEls.length; s2++) {
            if (used.has(sEls[s2])) continue;
            if (sEls[s2].tagName === 'P') { pEl = sEls[s2]; used.add(pEl); break; }
            if (sEls[s2].tagName === subTag) break;
          }
          pairs.push({ title: heading.textContent.trim(), content: pEl ? pEl.textContent.trim() : '', hEl: heading, pEl: pEl });
          used.add(heading);
        }
        if (pairs.length > 0) {
          var box = document.createElement('div');
          box.className = 'key-takeaways-box';
          var grid = document.createElement('div');
          grid.className = 'key-takeaways-grid';
          box.appendChild(grid);
          pairs.forEach(function(p) {
            var card = document.createElement('div');
            card.className = 'takeaway-card';
            card.innerHTML = '<div class="takeaway-title">' + p.title + '</div><div class="takeaway-content">' + p.content + '</div>';
            grid.appendChild(card);
          });
          ktHeading.parentNode.insertBefore(box, ktHeading.nextSibling);
          pairs.forEach(function(p) {
            if (p.hEl) p.hEl.classList.add('edu__is-hidden');
            if (p.pEl) p.pEl.classList.add('edu__is-hidden');
          });
        }
      }
    })();

    /* ── Auto-wrap tables in .table-wrapper ── */
    var tables = content.querySelectorAll('table.cq-table');
    tables.forEach(function(table) {
      if (table.parentElement && table.parentElement.classList.contains('table-wrapper')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    /* ── Water Drop Bullets ── */
    var uls = content.querySelectorAll('ul:not(.no-custom-bullets):not(.key-takeaways-grid)');
    uls.forEach(function(ul) {
      /* Skip lists that use their own bullet styling (checks, pros/cons) */
      if (ul.classList.contains('check-list')) return;
      if (ul.classList.contains('edu__drop-list')) return;
      if (ul.closest('.pros-col') || ul.closest('.cons-col')) return;
      ul.classList.add('edu__drop-list');
      var lis = ul.querySelectorAll(':scope > li');
      lis.forEach(function(li) {
        if (li.querySelector(':scope > .edu__drop-bullet')) return;
        li.classList.add('edu__drop-item');
        var before = document.createElement('span');
        before.className = 'edu__drop-bullet';
        before.setAttribute('aria-hidden', 'true');
        li.insertBefore(before, li.firstChild);
      });
    });

    /* ── Remove duplicate FAQ/TOC/footer markup embedded in article body ── */
    var killSelectors = [
      '.portable-faq-container',
      '#portable-faq-target',
      '.cq-toc-box',
      '.blog-footer-isolated'
    ];
    killSelectors.forEach(function(sel) {
      var els = content.querySelectorAll(sel);
      els.forEach(function(el) { el.remove(); });
    });
    /* Remove any inline scripts from article body that handle FAQ/TOC */
    var inlineScripts = content.querySelectorAll('script');
    inlineScripts.forEach(function(s) {
      var txt = s.textContent || '';
      if (txt.indexOf('initPortableFAQ') > -1 || txt.indexOf('initKeyTakeaways') > -1 || txt.indexOf('cq-toc') > -1) {
        s.remove();
      }
    });
    /* Remove any stray style blocks from article body */
    var inlineStyles = content.querySelectorAll('style');
    inlineStyles.forEach(function(s) {
      var txt = s.textContent || '';
      if (txt.indexOf('portable-faq') > -1 || txt.indexOf('cq-toc') > -1 || txt.indexOf('blog-footer') > -1) {
        s.remove();
      }
    });
    /* Remove elements with faq-content-screenreader-only (left by old FAQ scripts) */
    var srOnly = content.querySelectorAll('.faq-content-screenreader-only');
    srOnly.forEach(function(el) { el.classList.remove('faq-content-screenreader-only'); });

    /* ── FAQ Accordion Builder ── */
    var faqH2 = null;
    var allH2sForFaq = content.querySelectorAll('h2');
    for (var i = 0; i < allH2sForFaq.length; i++) {
      var txt = allH2sForFaq[i].textContent.toLowerCase();
      if (txt.indexOf('frequently asked') > -1 || txt.indexOf('faq') > -1) {
        faqH2 = allH2sForFaq[i];
        break;
      }
    }

    var faqTargetId = null;
    if (faqH2) {
      /* Give the FAQ H2 an id for TOC linking */
      if (!faqH2.id) faqH2.id = 'faqs';
      faqTargetId = faqH2.id;

      var sectionEls = [];
      var cur = faqH2.nextElementSibling;
      while (cur && cur.tagName !== 'H2' && cur.tagName !== 'H1' && cur.tagName !== 'SCRIPT') {
        sectionEls.push(cur);
        cur = cur.nextElementSibling;
      }

      var faqItems = [];
      for (var j = 0; j < sectionEls.length; j++) {
        var el = sectionEls[j];
        if (el.tagName === 'H3') {
          var contentEls = [];
          for (var k = j + 1; k < sectionEls.length; k++) {
            if (sectionEls[k].tagName === 'H3' || sectionEls[k].tagName === 'H2') break;
            if (['P', 'UL', 'OL', 'DIV'].indexOf(sectionEls[k].tagName) > -1) {
              contentEls.push(sectionEls[k]);
            }
          }
          faqItems.push({ question: el.textContent.trim(), contentEls: contentEls });
        }
      }

      if (faqItems.length > 0) {
        var faqTarget = document.getElementById('edu-faq-target');
        faqTarget.hidden = false;
        faqTarget.id = 'edu-faq-target';

        var title = document.createElement('h2');
        title.className = 'faq-title';
        title.id = 'edu-faq-section';
        title.textContent = faqH2.textContent;
        faqTarget.appendChild(title);

        faqItems.forEach(function(item, idx) {
          /* W3C ARIA accordion pattern: heading > button[aria-expanded] + content[role=region] */
          var faqItem = document.createElement('div');
          faqItem.className = 'faq-item';

          var qH3 = document.createElement('h3');
          qH3.className = 'faq-question';

          var btn = document.createElement('button');
          btn.className = 'faq-trigger';
          btn.type = 'button';
          var answerId = 'edu-faq-a-' + (idx + 1);
          btn.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-controls', answerId);
          btn.textContent = item.question;
          qH3.appendChild(btn);
          faqItem.appendChild(qH3);

          var contentDiv = document.createElement('div');
          contentDiv.id = answerId;
          contentDiv.className = 'faq-content';
          contentDiv.setAttribute('role', 'region');
          contentDiv.hidden = true;
          item.contentEls.forEach(function(ce) { contentDiv.appendChild(ce.cloneNode(true)); });
          if (item.contentEls.length === 0) {
            var p = document.createElement('p');
            p.textContent = 'No answer provided.';
            contentDiv.appendChild(p);
          }
          faqItem.appendChild(contentDiv);

          btn.addEventListener('click', function() {
            var expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            contentDiv.hidden = expanded;
          });

          faqTarget.appendChild(faqItem);
        });

        /* Remove original FAQ content from DOM entirely (prevents duplicate H2) */
        sectionEls.forEach(function(se) { se.remove(); });
        faqH2.remove();
      }
    }

    /* ── Inline TOC Generator ── */
    (function() {
      var itocBox = document.getElementById('edu-itoc-box');
      if (!itocBox) return;

      /* Get all visible H2s and H3s (exclude hidden FAQ content and key takeaways heading) */
      var allHeadings = content.querySelectorAll('h2, h3');
      var tocEntries = [];
      var skipUntilNextH2 = false;

      allHeadings.forEach(function(heading, idx) {
        /* Skip if it's hidden FAQ content */
        if (heading.classList.contains('edu-faq-hidden')) return;

        /* Skip key takeaways heading */
        if (heading.classList.contains('key-takeaways-heading')) {
          if (heading.tagName === 'H2') skipUntilNextH2 = true;
          return;
        }

        /* Skip content under key takeaways H2 until next H2 */
        if (skipUntilNextH2) {
          if (heading.tagName === 'H2') {
            skipUntilNextH2 = false;
          } else {
            return;
          }
        }

        /* Skip headings inside hidden containers */
        if (heading.closest('.portable-faq-container, .cq-toc-box, .edu-faq-container, .blog-footer-isolated')) return;

        /* Skip "Key Takeaways" text */
        var headText = heading.textContent.toLowerCase().trim();
        if (headText.indexOf('key takeaway') > -1 || headText.indexOf('quick takeaway') > -1) return;

        /* Skip FAQ H2 (already removed, but guard) */
        if (heading === faqH2) return;

        /* Skip hidden elements */
        if (heading.offsetParent === null && heading.style.display === 'none') return;

        var id = heading.id || 'edu-s-' + idx;
        heading.id = id;

        tocEntries.push({
          tag: heading.tagName,
          text: heading.textContent.trim(),
          id: id,
          el: heading
        });
      });

      /* Add FAQ entry if accordion exists */
      var faqTargetEl = document.getElementById('edu-faq-target');
      if (faqTargetEl && !faqTargetEl.hidden) {
        tocEntries.push({
          tag: 'H2',
          text: 'Frequently Asked Questions',
          id: 'edu-faq-target',
          el: faqTargetEl
        });
      }

      if (tocEntries.length === 0) {
        /* No headings found — hide the reserved TOC space */
        itocBox.hidden = true;
        var itocDivider = document.getElementById('edu-itoc-divider');
        if (itocDivider) itocDivider.hidden = true;
        return;
      }

      /* Build the inline TOC structure */
      /* Title bar */
      var titleBar = document.createElement('div');
      titleBar.className = 'edu__itoc-title';
      titleBar.innerHTML = '<span>In This Article</span><svg class="edu__itoc-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      itocBox.appendChild(titleBar);

      /* Content container */
      var tocContent = document.createElement('div');
      tocContent.className = 'edu__itoc-content';
      itocBox.appendChild(tocContent);

      /* Group headings: H2s are top-level, H3s nest under the preceding H2 */
      var groups = [];
      for (var g = 0; g < tocEntries.length; g++) {
        if (tocEntries[g].tag === 'H2') {
          groups.push({ h2: tocEntries[g], h3s: [] });
        } else if (tocEntries[g].tag === 'H3' && groups.length > 0) {
          groups[groups.length - 1].h3s.push(tocEntries[g]);
        }
      }

      /* Build TOC items */
      groups.forEach(function(group) {
        if (group.h3s.length === 0) {
          /* Simple link — no sub-items */
          var link = document.createElement('a');
          link.className = 'edu__itoc-link';
          link.href = '#' + group.h2.id;
          link.innerHTML = '<span class="edu__itoc-text">' + group.h2.text + '</span>';
          link.addEventListener('click', function(e) {
            e.preventDefault();
            var targetEl = document.getElementById(this.getAttribute('href').substring(1));
            if (targetEl) {
              targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
              history.pushState(null, null, this.getAttribute('href'));
            }
          });
          tocContent.appendChild(link);
        } else {
          /* Dropdown with sub-items */
          var dropdown = document.createElement('div');
          dropdown.className = 'edu__itoc-dropdown';

          var trigger = document.createElement('div');
          trigger.className = 'edu__itoc-dropdown-trigger';
          trigger.innerHTML = '<a href="#' + group.h2.id + '" class="edu__itoc-text">' + group.h2.text + '</a><svg class="edu__itoc-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"></polyline></svg>';
          dropdown.appendChild(trigger);

          /* H2 link click — smooth scroll */
          var h2Link = trigger.querySelector('.edu__itoc-text');
          h2Link.addEventListener('click', function(e) {
            e.preventDefault();
            var targetEl = document.getElementById(this.getAttribute('href').substring(1));
            if (targetEl) {
              targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
              history.pushState(null, null, this.getAttribute('href'));
            }
          });

          /* Chevron click — toggle submenu */
          var chevron = trigger.querySelector('.edu__itoc-chevron');
          chevron.addEventListener('click', function(e) {
            e.stopPropagation();
            var dd = this.closest('.edu__itoc-dropdown');
            dd.classList.toggle('expanded');
          });

          /* Submenu */
          var submenu = document.createElement('div');
          submenu.className = 'edu__itoc-submenu';

          group.h3s.forEach(function(h3) {
            var subLink = document.createElement('a');
            subLink.className = 'edu__itoc-subitem';
            subLink.href = '#' + h3.id;
            subLink.textContent = h3.text;
            subLink.addEventListener('click', function(e) {
              e.preventDefault();
              var targetEl = document.getElementById(this.getAttribute('href').substring(1));
              if (targetEl) {
                targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.pushState(null, null, this.getAttribute('href'));
              }
            });
            submenu.appendChild(subLink);
          });

          dropdown.appendChild(submenu);
          tocContent.appendChild(dropdown);
        }
      });

      /* Remove reserved min-height now that TOC is built */
      itocBox.classList.remove('edu__itoc-box--reserved');

      /* Title click — toggle expand/collapse */
      titleBar.addEventListener('click', function() {
        var arrow = titleBar.querySelector('.edu__itoc-arrow');
        var isExpanded = tocContent.classList.contains('expanded');
        if (isExpanded) {
          tocContent.classList.remove('expanded');
          titleBar.classList.remove('expanded');
          arrow.classList.remove('expanded');
        } else {
          tocContent.classList.add('expanded');
          titleBar.classList.add('expanded');
          arrow.classList.add('expanded');
        }
      });
    })();

    document.querySelectorAll('[data-edu-copy-link]').forEach(function(btn) {
      var initialHtml = btn.innerHTML;
      btn.addEventListener('click', function() {
        var copy = navigator.clipboard && navigator.clipboard.writeText
          ? navigator.clipboard.writeText(window.location.href)
          : Promise.reject();

        copy.then(function() {
          btn.innerHTML = '&#10003;';
          window.setTimeout(function() {
            btn.innerHTML = initialHtml;
          }, 2000);
        }).catch(function() {
          window.prompt('Copy this link', window.location.href);
        });
      });
    });

    var backToTop = document.getElementById('edu-btt');
    if (backToTop) {
      backToTop.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  });

  function updateScrollUi() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight;
    if (height <= 0) height = 1;
    var btn = document.getElementById('edu-btt');
    var bar = document.getElementById('edu-progress-bar');
    if (btn) btn.classList.toggle('show', scrollTop > 600);
    if (bar) bar.style.width = (scrollTop / height * 100) + '%';
  }

  var scrollTicking = false;
  function requestScrollUiUpdate() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function() {
      scrollTicking = false;
      updateScrollUi();
    });
  }

  window.addEventListener('scroll', requestScrollUiUpdate, { passive: true });
  window.addEventListener('resize', requestScrollUiUpdate, false);
  setTimeout(updateScrollUi, 100);
})();
